import useRefreshAccessToken from '@/core/hooks/auth/useRefreshAccessToken/useRefreshAccessToken';

export default useRefreshAccessToken;
